import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-compact-up', 'ChevronCompactUp', [["path",{"d":"M4 13l8 -3l8 3","key":"svg-0"}]]);